export const productsTab = {
	label: "Cadastro base de produto",
	description: "Lista de produtos cadastrados na organização e suas informações basais.",
	header: {
		counter: "{{amount}} Produtos",
		search: "Pesquisar",
		add: "Adicionar produto",
		inventory: "Alterar inventário",
		export: "Exportar produtos",
		addPlaces: "Adicionar locais",
		editPlaces: "Editar locais",
		deleteProduct: "Excluir (1) produto",
		deleteMultipleProducts: "Excluir ({{products}}) produtos",
	},
	addEditProductModal: {
		add: "Adicionar produto",
		update: "Atualizar produto",
		edit: "Editar produto",
		undefined: "Indefinido",
		unavailable: "Indisponível",
		form: {
			name: {
				label: "Nome do Produto",
				placeholder: "Digite um nome para o produto",
				error: "Use apenas caracteres válidos",
			},
			type: {
				label: "Tipo",
				placeholder: "Selecione um tipo de produto",
			},
			category: {
				label: "Categoria",
				info: "Você estará criando uma nova categoria",
				placeholder: "Selecione ou crie uma categoria",
				error: "Escolha ou crie uma categoria",
			},
			code: {
				label: "SKU",
				placeholder: "Digite um SKU",
				tooltip: "Caso não seja preenchido, o código será gerado automaticamente",
				error: "O SKU não pode conter o caractere #",
			},
			ncm: {
				label: "NCM",
				placeholder: "Digite um NCM",
				error: "O NCM deve ter 8 dígitos",
			},
			photo: "Foto",
			hasAlcohol: "Contém álcool?",
			error: "Esse campo é obrigatório",
		},
	},
	inventoryUpdate: {
		label: "Alterar inventário",
		import: "Importar planilha",
		download: "Baixar planilha",
		columns: {
			id: "Id do produto",
			name: "Nome",
			category: "Categoria",
			type: "Tipo do produto",
			hasAlcohol: "Contém álcool?",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - Ncm",
		},
	},
	exportProducts: {
		products: "Produtos",
		warningNotification: "Produtos não modificados",
		columns: {
			id: "Id do produto",
			title: "Nome",
			category: "Categoria",
			places: "Locais",
			fiscalNcm: "NCM",
			fiscalCode: "SKU",
			kind: "Tipo de produto",
			type: "Tipo",
			hasAlcohol: "Contém álcool?",
			description: "Descrição",
		},
	},
	productForm: {
		alcoholLabel: "Contém álcool?",
		categoryLabel: "Categoria",
		categoryPlaceholder: "Digite a categoria do produto",
		createProduct: "Criar produto de inventário",
		editProduct: "Editar produto de inventário",
		fiscalCodelabel: "SKU",
		fiscalCodePlacehodler: "Digite o código SKU do produto",
		fiscalCodeError: "Apenas número, pontos e letras",
		ncmLabel: "NCM",
		ncmPlaceholder: "Digite o código NCM do produto",
		photolabel: "Foto",
		productNameLabel: "Nome do produto",
		productNamePlaceholder: "Digite o nome do produto",
		productTypelabel: "Tipo",
		productTypePlaceholder: "Selecione o tipo do produto",
		placesLabel: "Locais",
		placesPlaceholder: "Selecione os locais do produto",
		price: "Preço",
		priceTooltip:
			"A mudança do preço neste campo altera o preço do produto para todos os places vinculados",
		editPrice: "Alterar preço",
		saveEditProduct: "Salvar alterações",
		saveProduct: "Salvar produto",
		confirmProductPrice: {
			goBack: "Voltar para edição",
			confirm: "Confirmar alteração",
			title: "Confirmar ajuste",
			description: {
				title: "Deseja confirmar a alteração de preço?",
				subtitle:
					"Os places vinculados passarão a ter o novo valor de <b>{{productValue}}</b> para o produto <b>{{productName}}.</b>",
			},
		},
	},
	types: {
		product: "Produto",
		supply: "Insumo",
	},
	rows: {
		products: "Produtos",
		type: "Tipo",
		places: "Locais",
		noProducts: "Sem produtos",
		fiscalCode: "SKU",
	},
	selectPlaces: {
		label: "Selecionar locais",
		search: "Pesquisar locais",
	},
	removeProduct: {
		label: "Remover produto",
		title: "Deseja realmente remover o produto?",
	},
	modalDelete: {
		title: "Excluir produto",
		description:
			"Ao confirmar a ação você exclui permanentemente o produto. Deseja continuar?",
	},
	modalDeleteMultipleProducts: {
		title: "Excluir produtos",
		description:
			"Ao remover os produtos selecionados eles serão excluídos de todos os locais, e não será possível reverter essa ação.",
		confirm: "Deseja excluir mesmo assim?",
	},
	link: "Vínculo",
	links: "Vínculos",
	productPlacesModal: {
		title: "Vínculos do produto",
		description: "Relação de locais onde o produto está presente",
		seePlace: "Ver local",
	},
};
